export const LOAD_PAYMENTS = 'Dyzio/Payments/LOAD_PAYMENTS';
export const LOAD_PAYMENTS_ERROR = 'Dyzio/Payments/LOAD_PAYMENTS_ERROR';
export const LOAD_PAYMENTS_SUCCESS = 'Dyzio/Payments/LOAD_PAYMENTS_SUCCESS';



/** WEBPACK FOOTER **
 ** ./src/containers/payments/constants.js
 **/